import './SavingTileCard.scss';
import clsx from 'clsx';
import React, { memo, ReactNode } from 'react';

type Props = {
  icon: ReactNode;
  title: ReactNode;
  label: ReactNode;
  value: ReactNode;
  details: Array<{ detailLabel: ReactNode; detailValue: ReactNode }>;
  bordered?: boolean;
};

export const SavingTileCard = memo(({
  icon,
  title,
  label,
  value,
  details,
  bordered,
}: Props) => (
  <div className={clsx({
    'bp-saving-tile-card': true,
    'bp-saving-tile-card--bordered': bordered,
  })}
  >
    <div className="bp-saving-tile-card__header">
      <div className="bp-saving-tile-card__icon">
        {icon}
      </div>

      <div className="bp-saving-tile-card__title">
        {title}
      </div>
    </div>

    <div className="bp-saving-tile-card__body">
      <div className="bp-saving-tile-card__label">
        {label}
      </div>

      <div className="bp-saving-tile-card__value-wrapper">
        <div className="bp-saving-tile-card__value">
          {value}
        </div>
      </div>
    </div>

    <div className="bp-saving-tile-card__details">
      {details.map(({ detailLabel, detailValue }, index) => (
        <div
          // eslint-disable-next-line react/no-array-index-key
          key={index}
          className={clsx({
            'bp-saving-tile-card__detail': true,
            'bp-saving-tile-card__detail--bordered': index !== details.length - 1,
          })}
        >
          <div className="bp-saving-tile-card__label">
            {detailLabel}
          </div>

          <div className="bp-saving-tile-card__detail-value">
            {detailValue}
          </div>
        </div>
      ))}
    </div>
  </div>
));
